import { Box } from "@chakra-ui/react";
import { TenantUsuarioFormulario } from "features/tenants/typings/tenant";
import { Control } from "react-hook-form";
import { Col, Row } from "antd";
import Field from "components/Input/Field";
import InputMask from "components/Input/InputMask";
import { isValidCPF } from "@brazilian-utils/brazilian-utils";
import { isValidEmail } from "infra/helpers/isValidEmail";

import FormContatos from "components/FormContatos";

function DadosDoResponsavel({
  control,
}: {
  control: Control<TenantUsuarioFormulario, object>;
  edit?: boolean;
}) {
  return (
    <>
      <Row gutter={12}>
        <Box as={Col} xs={12} mb={6}>
          <Field
            label="Nome"
            control={control}
            name="pessoa.nome"
            rules={{ required: "Campo obrigatório" }}
          />
        </Box>

        <Box as={Col} xs={12} mb={6}>
          <Field
            label="CPF"
            control={control}
            name="pessoa.documento"
            rules={{
              required: true,
              validate: (v) => isValidCPF(v) || "CPF inválido",
            }}
            render={({ field, isInvalid }) => (
              <InputMask
                {...field}
                isInvalid={isInvalid}
                mask="999.999.999-99"
                placeholder="XXX.XXX.XXX-XX"
              />
            )}
          />
        </Box>
      </Row>

      <Row gutter={12}>
        {/* <Box as={Col} xs={8} mb={6}>
          <Field label="RG" control={control} name="pessoa.rg" />
        </Box> */}

        <Box as={Col} xs={12} mb={6}>
          <Field
            label="Data de Nascimento"
            control={control}
            name="pessoa.dataNascimento"
            rules={{ required: "Campo obrigatório" }}
            inputProps={{
              type: "date",
            }}
          />
        </Box>

        <Box as={Col} xs={12} mb={6}>
          <Field
            label={"Email"}
            control={control}
            name="pessoa.email"
            inputProps={{
              placeholder: "seuemail@seuprovedor.com",
            }}
            rules={{
              required: "Campo obrigatório",
              validate: (v) => isValidEmail(v) || "Email inválido",
            }}
          />
        </Box>

        {/* <Box as={Col} xs={12} mb={6}>
          <Field
            label="Telefone"
            control={control}
            name="pessoa.telefone"
            render={({ field }) => {
              return (
                <InputMask
                  {...field}
                  mask="(99) 99999-9999"
                  placeholder="(XX) XXXXX-XXXX"
                />
              );
            }}
          />
        </Box> */}

        {/* <Box as={Col} xs={8} mb={6}>
          <Field
            label="Sexo"
            control={control}
            name="pessoa.sexo"
            render={({ field }) => <SelectSexo {...field} />}
          />
        </Box> */}
      </Row>

      <FormContatos hideCobranca control={control} name="pessoa.contatos" />

      <Row gutter={12}>
        {/* <Box as={Col} xs={12} mb={6}>
          <Field label="PIS/NIS" control={control} name="pessoa.pis" />
        </Box> */}
      </Row>
    </>
  );
}

export default DadosDoResponsavel;
